import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AppService } from '../app.service';

export const calendarResolver: ResolveFn<unknown> = (route, state) => {
  const appService = inject(AppService);

  return appService.getCalendarTodayEventNew(

  );
};
